export function isGranted(action, object) {
    if (!object || !object['@permissions']) {
        return false;
    }

    return object['@permissions'].indexOf(action) !== -1;
}
